<template>
    <b-modal id="modal-konfirmasi" title="Konfirmasi Gadai" size="lg" 
        no-close-on-backdrop no-close-on-esc :hide-header-close="isSubmitting"
        :ok-title="isSubmitting ? 'Menyimpan...' : 'Simpan'" 
        :ok-disabled="isSubmitting"
        @ok.prevent="doSubmit" auto-focus-button="ok"
        cancel-title="Tutup"
    >
        Dengan ini akan melakukan penggadaian dengan data sebagai berikut:
        <div class="detail-data-wrapper mb-4 mt-4">
            <h6 class="form-title mb-2">ANGGOTA</h6>
            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">No. Anggota</b-col>
                <b-col>
                    {{ anggota.no }}
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Nama</b-col>
                <b-col>
                    {{ anggota.nama }}
                </b-col>
            </b-row>
        </div>
        <div class="detail-data-wrapper mb-4">
            <h6 class="form-title mb-2">DATA GADAI</h6>
            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Barang</b-col>
                <b-col>
                    <div v-if="rincian.namaBarang != null">
                        {{ rincian.namaBarang }}
                        <br>
                        <br>
                        {{ rincian.gosokCapKwitansi }}
                        <br>
                        <br>
                        {{ rincian.batuBarang }}
                    </div>
                    <div v-else>
                        {{ namaLengkapBarang }}
                    </div>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col v-if="rincian.detailBatu != null && rincian.detailBatu.length != 0" cols="5" class="detail-data-label">Potongan Berat</b-col>
                <b-col>
                    <div v-for="item of rincian.detailBatu" >
                        - {{ item }}
                    </div>
                </b-col>
                <!-- <ul>
                    <li v-for="item of rincian.detailBatu">
                        {{ item }}
                    </li>
                </ul> -->
            </b-row>
            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Nilai Pinjaman</b-col>
                <b-col>
                    Rp. {{ $helper.addThousandSeparator(nilaiPinjaman) }}
                </b-col>
            </b-row>
            <b-row class="mb-2" v-if="rincian.biayaJasaPertama != null">
                <b-col cols="5" class="detail-data-label">Biaya Jasa</b-col>
                <b-col>
                    Rp. {{ $helper.addThousandSeparator(rincian.biayaJasaPertama) }}
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Biaya Admin</b-col>
                <b-col>
                    Rp. {{ $helper.addThousandSeparator(rincian.biayaAdmin) }}
                </b-col>
            </b-row>
            <b-row class="mb-2" v-if="rincian.biayaAsuransi != null">
                <b-col cols="5" class="detail-data-label">Biaya Asuransi</b-col>
                <b-col>
                    Rp. {{ $helper.addThousandSeparator(rincian.biayaAsuransi) }}
                </b-col>
            </b-row>
            <b-row class="mb-2" v-if="rincian.rekeningNasabah != null">
                <b-col cols="5" class="detail-data-label">Biaya Admin Bank</b-col>
                <b-col>
                    Rp. {{  $helper.addThousandSeparator(rincian.rekeningNasabah.biayaBank)   }}
                </b-col>
            </b-row>
            <b-row class="mb-2" v-if="rincian.voucherDiskon != null">
                <b-col cols="5" class="detail-data-label">Potongan Jasa</b-col>
                <b-col>
                    Rp. {{ $helper.addThousandSeparator(rincian.voucherDiskon) }}
                    <div class="small text-muted">({{ rincian.voucherPersenDiskon }}% - Maks Rp. {{ $helper.addThousandSeparator(rincian.voucherMaxDiskon) }})</div>
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Nasabah mendapatkan</b-col>
                <b-col>
                    Rp. {{hitungJumlahDiterima}}
                </b-col>
            </b-row>
        </div>
        <div class="detail-data-wrapper mb-4 mt-4">
            <h6 class="form-title mb-2">Data Pencairan</h6>
            <b-row class="mb-2">
                <b-col cols="5" class="detail-data-label">Metode Pencairan</b-col>
                
                <b-col v-if="rincian.rekeningNasabah == null || rincian.rekeningNasabah == undefined">
                    Tunai
                </b-col>
                <b-col v-else>
                    Non Tunai
                </b-col>
            </b-row>
    
            <b-row class="mb-2" v-if="rincian.rekeningNasabah != null || rincian.rekeningNasabah != undefined" >
                <b-col cols="5" class="detail-data-label">Rekening Tujuan</b-col>
                <b-col>
                    {{ rincian.rekeningNasabah.noRekening }} - {{ rincian.rekeningNasabah.namaRekening }} ({{ rincian.rekeningNasabah.namaBank }})
                </b-col>
            </b-row>
        </div>
        Pastikan anda sudah mengisi data penggadaian dengan sebenar-benarnya sebelum menyimpan.
    </b-modal>
</template>

<script>
import { watch } from 'fs';

export default {
    name: 'modal-konfirmasi',
    props: {
        isSubmitting: { type: Boolean, required: true },
        nilaiPinjaman: { type: Number, required: true },
        anggota: { type: Object, required: true },
        rincian: { type: Object, required: true },
        namaLengkapBarang: { type: String, required: true },
        // rekening: {type: Object}
    },
    data() {
        return {
           biaya : 0
        }
    },
    methods: {
        int(){
          
        },
        doSubmit() {
            this.$emit("exec-submit", (this.rincian.rekeningNasabah != null) ?1 :0, (this.rincian.rekeningNasabah != null) ?this.rincian.rekeningNasabah.id :0)
        }

    },

    computed: {
    hitungJumlahDiterima() {
        let jumlahDiterima = 0
        if(this.rincian.rekeningNasabah != null){
           jumlahDiterima = this.rincian.jumlahDiterima - this.rincian.rekeningNasabah.biayaBank
           jumlahDiterima = this.$helper.addThousandSeparator(jumlahDiterima) 
        }else{
            jumlahDiterima = this.$helper.addThousandSeparator(this.rincian.jumlahDiterima) 
        }
      return jumlahDiterima 
    },
    }
}
</script>